import React from 'react';

function PlayerStatsAPI({seasonStats}) {


    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped table-hover">
                <thead>
                    <tr>
                        <th>Season</th>
                        <th>Team</th>
                        <th>League</th>
                        <th>FP</th>
                        <th>G</th>
                        <th>A</th>
                    </tr>
                </thead>
                <tbody>

                    {seasonStats.map((season, index) => {
                        return (
                            <tr key={index}>           
                                
                                <td>{season.season}</td>
                                <td>{season.team_name}</td>
                                <td>{season.league}</td>
                                <td>{season.games.appearences}</td>
                                <td>{season.goals.total}</td>
                                <td>{season.goals.assists}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
export default PlayerStatsAPI